import { all, fork, takeEvery } from "redux-saga/effects";

import {
  loginSaga,
  changePasswordSaga,
  forgotPasswordSaga,
  logoutSaga,
  getCaptchaSaga,
  verifyCaptchaSaga,
} from "./Login";
import {
  loginV2Saga,
  verifyOtpSaga,
  getCaptchaV2Saga,
  logoutV2Saga,
  resendOTPSaga,
} from "./LoginV2";
import { registerSaga } from "./Register";
import { GetClinicSaga, getOneClinicSaga } from "./Clinic";
import {
  verifyEdcMemberSaga,
  verifyEdcDobSaga,
  inquiryPaymentSaga,
  voidClaimSaga,
} from "./Edc";
import { registerEdcMemberSaga } from "./RegisterEdc";
import {
  getDiagnosticSaga,
  checkoutPaymentSaga,
  claimItemSaga,
  calculateItemSaga,
  AllinOnePaymentTransaction,
} from "./EdcProcessPayment";
import {
  getAllTransactionSaga,
  getFilterTransactionSaga,
  getPerTransactionAllSaga,
  getPerTransactionFilterSaga,
  createTransactionSaga,
  searchTransactionByTraceNoSaga,
  getClaimLockedSaga,
  putChangeClaimLockedSaga,
} from "./Transaction";
import { getIcdAllSaga, icdSearchSaga } from "./Icd";
import {
  verifyUserSaga,
  getAllUserSaga,
  getUsersByProviderNameSaga,
} from "./VerifyUser";
import {
  getEmployeeDataSaga,
  enrollFaceSaga,
  getAllFaceSaga,
} from "./Biometrics";
import { getDocForm } from "./DocForm";

import { checkEgibilityFoneSaga } from "./EgibilityFone";
import { registerFoneSaga } from "./RegisterFone";
import { exclusionFoneSaga } from "./ExclusionFone";
import { submitClaimFoneSaga } from "./SubmitClaimFone";
import { SSOFoneSaga } from "./SSOFone";
import { updateUsernameSaga } from "./ChangeUsername";
import { RegisterFingerPrint } from "./FingerprintRegister";
import { CheckSessionSaga } from "./CheckSession";
import { FingerPrintMatch } from "./FingerPrrintMatch";
import { FingerPrintMatchByCard } from "./FingerPrintMatchByCard";
import { FingerPrintUNID } from "./FinerPrintByUnid";
import { uploadFileClaimSaga } from "./uploadFileClaim";
import { invoiceListSaga } from "./InvoiceList";
import { claimListSaga } from "./ClaimList";
import { claimStatusSaga } from "./ClaimStatus";
import { claimDocSaga } from "./ClaimDoc";
import { createInvoiceSaga } from "./CreateInvoice";
import { deleteDocSaga } from "./DeleteDocClaim";
// import { claimPendingListSaga } from "./ClaimListPending";
import { claimListNotifSaga } from "./ClaimListPending";
import { claimPendingDetailWatcher } from "./ClaimPendingDetail";
import { specialitySaga, specialityStatusSaga } from "./Speciality";

export default function* rootSaga() {
  yield all([
    fork(claimPendingDetailWatcher),
    // yield takeEvery("REQ_CLAIM_PENDING_LIST", claimPendingListSaga),
    yield takeEvery("REQ_DELETE_CLAIM_DOC", deleteDocSaga),
    yield takeEvery("REQ_CREATE_INVOICE", createInvoiceSaga),
    yield takeEvery("REQ_CLAIM_DOC", claimDocSaga),
    yield takeEvery("REQ_CLAIM_STATUS", claimStatusSaga),
    yield takeEvery("REQ_INVOICE_LIST", invoiceListSaga),
    yield takeEvery("REQ_CLAIM_LIST", claimListSaga),
    yield takeEvery("REQ_UPLOAD_FILE_CLAIM", uploadFileClaimSaga),
    yield takeEvery("REQ_SPECIALITY_STATUS", specialityStatusSaga),
    yield takeEvery("REQ_SPECIALITY", specialitySaga),
    yield takeEvery("REQ_SESSION_REQUESTED", CheckSessionSaga),
    yield takeEvery("REQ_REGISTER_FINGERPRINT_REQUESTED", RegisterFingerPrint),
    yield takeEvery("REQ_CHANGE_USERNAME_REQUESTED", updateUsernameSaga),
    yield takeEvery("REQ_SUBMIT_CLAIM_FONE", submitClaimFoneSaga),
    yield takeEvery("REQ_FONE_EXCLUSION", exclusionFoneSaga),
    yield takeEvery("SSO_FONE_REQUESTED", SSOFoneSaga),
    yield takeEvery("REQ_REGISTER_FONE", registerFoneSaga),
    yield takeEvery("REQ_ONE_ELIGIBILITY", checkEgibilityFoneSaga),
    yield takeEvery("REQ_LOGIN_REQUESTED", loginSaga),
    yield takeEvery("REQ_LOGIN_V2_REQUESTED", loginV2Saga),
    yield takeEvery("VERIFY_OTP_REQUESTED", verifyOtpSaga),
    yield takeEvery("RESEND_OTP_REQUESTED", resendOTPSaga),
    yield takeEvery("REQ_CAPTCHA_SVG_V2", getCaptchaV2Saga),
    yield takeEvery("REQ_REGISTER_REQUESTED", registerSaga),
    yield takeEvery("REQ_GET_CLINIC_REQUESTED", GetClinicSaga),
    yield takeEvery("REQ_VERIFY_MEMBER_EDC_REQUESTED", verifyEdcMemberSaga),
    yield takeEvery("REQ_VERIFY_MEMBER_EDC_DOB_REQUESTED", verifyEdcDobSaga),
    yield takeEvery("REQ_REGISTER_MEMBER_EDC_REQUESTED", registerEdcMemberSaga),
    yield takeEvery("REQ_GET_DIAGNOSTIC_REQUESTED", getDiagnosticSaga),
    yield takeEvery("REQ_CHECKOUT_PAYMENT_REQUESTED", checkoutPaymentSaga),
    yield takeEvery("REQ_CLAIM_ITEM_REQUESTED", claimItemSaga),
    yield takeEvery("REQ_CALCULATE_ITEM_REQUESTED", calculateItemSaga),
    yield takeEvery("REQ_GET_ALL_TRANSACTION_REQUESTED", getAllTransactionSaga),
    yield takeEvery(
      "REQ_GET_FILTER_TRANSACTION_REQUESTED",
      getFilterTransactionSaga,
    ),
    yield takeEvery("REQ_CREATE_TRANSACTION_REQUESTED", createTransactionSaga),
    yield takeEvery(
      "REQ_GET_PER_TRANSACTION_ALL_REQUESTED",
      getPerTransactionAllSaga,
    ),
    yield takeEvery(
      "REQ_GET_PER_TRANSACTION_FILTER_REQUESTED",
      getPerTransactionFilterSaga,
    ),
    yield takeEvery("REQ_INQUIRY_PAYMENT_REQUESTED", inquiryPaymentSaga),
    yield takeEvery("REQ_VOID_CLAIM_REQUESTED", voidClaimSaga),
    yield takeEvery(
      "REQ_SEARCH_TRANSACTION_BY_TRACE_NO_REQUESTED",
      searchTransactionByTraceNoSaga,
    ),
    yield takeEvery("REQ_ICD_ALL_REQUESTED", getIcdAllSaga),
    yield takeEvery("REQ_ICD_SEARCH_REQUESTED", icdSearchSaga),
    yield takeEvery("REQ_VERIFY_USER_REQUESTED", verifyUserSaga),
    yield takeEvery("REQ_GET_ALL_USER_REQUESTED", getAllUserSaga),
    yield takeEvery(
      "REQ_GET_USER_BY_PROVIDER_NAME_REQUESTED",
      getUsersByProviderNameSaga,
    ),
    yield takeEvery("REQ_CHANGE_PASSWORD_REQUESTED", changePasswordSaga),
    yield takeEvery("REQ_GET_CLAIM_LOCKED_REQUESTED", getClaimLockedSaga),
    yield takeEvery("REQ_PUT_CLAIM_LOCKED_REQUESTED", putChangeClaimLockedSaga),
    yield takeEvery("REQ_FORGOT_PASSWORD_REQUESTED", forgotPasswordSaga),
    yield takeEvery("REQ_GET_EMPLOYEE_DATA_REQUESTED", getEmployeeDataSaga),
    yield takeEvery("REQ_POST_ENROLL_FACE_REQUESTED", enrollFaceSaga),
    yield takeEvery("REQ_GET_ALL_FACE_REQUESTED", getAllFaceSaga),
    yield takeEvery("REQ_GET_ONE_CLINIC_REQUESTED", getOneClinicSaga),
    yield takeEvery("REQ_CAPTCHA_SVG", getCaptchaSaga),
    yield takeEvery("VERIFY_CAPTCHA_SVG_REQUEST", verifyCaptchaSaga),
    yield takeEvery("REQ_LOGOUT", logoutSaga),
    yield takeEvery("REQ_LOGOUT_V2", logoutV2Saga),
    yield takeEvery("REQ_ONE_PAYMENT", AllinOnePaymentTransaction),
    yield takeEvery("REQ_FORM", getDocForm),
    yield takeEvery("REQ_MATCH_FINGERPRINT_REQUESTED", FingerPrintMatch),
    yield takeEvery(
      "REQ_MATCH_FINGERPRINT_CARD_REQUESTED",
      FingerPrintMatchByCard,
    ),
    yield takeEvery("REQ_FINGERPRINT_UNID_REQUESTED", FingerPrintUNID),
    //--//
    fork(claimListNotifSaga),
  ]);
}
